import { get } from "./http";
import {post} from "./http"

/**
 * 获取token
 * @param p {termNo: "", termType: ""}
 * @returns {Promise<unknown>}
 */
export const token = p => post("/sdsp/appwx/index/token", p);

export const queryOpenId = p => post("/sdsp/wx/auth/code", p);

/**

/**
 * 免密授权
 * @param p
 * @returns {Promise<unknown>}
 */
export const getOrderInfo = (p) => post("/sdsp/mipp/cashier/orderInfo", p);

/**
 * 验证处方信息
 * @param p
 * @returns {Promise<unknown>}
 */
export const verifyBill = (medOrgOrd) => get("/sdsp/mipp/cashier/verifyBill?medOrgOrd="+medOrgOrd)

export const unRegistRecord = (p) => post("/sdsp/mipp/cashier/unRegistRecord", p)

/**
 * 创建订单
 * @param  
 * @returns 
 */
export const createOrder = (p) => post("/sdsp/mipp/cashier/unifiedOrder", p)

export const presettle = (medOrgOrd, authCode) => get("/sdsp/mipp/cashier/preSettle?medOrgOrd="+medOrgOrd+"&authCode="+authCode)

export const queryBillsInfo = (medOrgOrd) => get("/sdsp/mipp/cashier/queryBillsInfo?medOrgOrd="+medOrgOrd)
